import { atom, useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { accountService } from '@/services/account.service';
import type { AccountsFilters } from '@/types';

export const accountsFiltersAtom = atom<AccountsFilters>({
  search: '',
  source: 'all',
  account_status: 'all',
  shadow_mode_enabled: 'all',
  v3: 'all'
});

export const accountsPaginationAtom = atom<{ page: number; pageSize: number }>({
  page: 1,
  pageSize: 25
});

const accountsQueryAtom = atomWithQuery((get) => {
  const filters = get(accountsFiltersAtom);
  const pagination = get(accountsPaginationAtom);
  return {
    queryKey: ['accounts', filters, pagination],
    queryFn: () => accountService.list({ ...filters, ...pagination })
  };
});

export const useAccounts = () => {
  const [result] = useAtom(accountsQueryAtom);
  return result;
};

export const useAccountsFilters = () => useAtom(accountsFiltersAtom);
export const useAccountsPagination = () => useAtom(accountsPaginationAtom);
